/**
 * mw-lena-note.js — Alpine component for the Lena sticky note.
 *
 * Shows once per visitor (localStorage) after they scroll past ~60% of
 * the viewport. Dismiss closes permanently. Listens to mwBus
 * 'lena-note:show' for explicit triggering.
 *
 * Registered via `alpine:init` (loaded in <head> before Alpine) so the
 * factory exists by the time Alpine evaluates `x-data="mwLenaNote"` —
 * otherwise Alpine resolves `open` against the global scope and finds
 * `window.open` (truthy → note shows on load).
 */
document.addEventListener('alpine:init', function () {
  if (!window.Alpine) return;
  var STORAGE_KEY = 'mw.lenaNoteSeen';
  window.Alpine.data('mwLenaNote', function () {
    return {
      open: false,
      dismissed: false,

      init: function () {
        try {
          if (localStorage.getItem(STORAGE_KEY) === '1') {
            this.dismissed = true;
            return;
          }
        } catch (_) { /* localStorage blocked — proceed anyway */ }

        var threshold = Math.max(300, window.innerHeight * 0.6);
        var self = this;
        var onScroll = function () {
          if (self.dismissed) return;
          if (window.scrollY > threshold) {
            self.open = true;
            window.removeEventListener('scroll', onScroll);
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });

        if (window.mwBus) {
          window.mwBus.on('lena-note:show', function () { self.open = true; });
        }
      },

      dismiss: function () {
        this.open = false;
        this.dismissed = true;
        try { localStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
        if (window.mwBus) window.mwBus.emit('lena-note:dismissed', {});
      }
    };
  });
});
